import { render, staticRenderFns } from "./McpAuditLog.vue?vue&type=template&id=267929b0"
import script from "./McpAuditLog.vue?vue&type=script&lang=js"
export * from "./McpAuditLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports